var common = require("../../../utiles/common.js");
var service = require("../../../utiles/service")

module.exports = {
    register: function () {
        document.createElement('attr-item')
        ko.components.register('attr-item', {
            viewModel: function (params) {
                var arrId = location.hash.replace("#/editAttr/", "").split('/');
                var $this = this;
                var param={
                    appId:arrId[1],
                    entitlementId:arrId[0],
                }
                $this.data = service.editAttr.info(param);
                $this.isenable = ko.observable("");
                if (!!$this.data.activeDate) {
                    $this.isenable("生效日期：" +common.timestampToTime($this.data.activeDate,"day") + "内生效");
                } else if (!!$this.data.expireDate) {
                    $this.isenable("生效日期：" +common.timestampToTime($this.data.expireDate,"day") + "后失效");
                } else {
                    $this.isenable("生效日期：" +"长期有效")
                }
                $this.accountId = $this.data.accountId;
                if($this.data.entitlementType=="OWNER"){
                    $this.type="拥有"
                }else if($this.data.entitlementType=="USERGRANT"){
                    $this.type="他人委托"
                }else{
                    $this.type="可使用"
                }
                $this.lastLoginDate = ko.computed(function(){
                    return common.timestampToTime($this.data.lastLoginDate);
                }) 
                $this.saveAttr = function(){
                    common.confirmAlert("请核查信息内容，是否保存?",function(){
                        if(common.validateEachAll($this.data.metas).valid){
                            var tags = $('.attr_item .inputtag').serializeObject();
                            var tagobj = {};
                            for(x in tags){
                                var item = tags[x].split(",");
                                item = $.grep(item, function(n) {return $.trim(n).length > 0;})
                                tagobj[x] = item;
                            }
                            var paramsData = {
                                extraProps:$.extend($('.attr_item input').serializeObject(),$('.attr_item select').serializeObject(),tagobj),
                                accountId:$this.accountId,
                                entitlementId:arrId[0]
                            }
                            if(service.editAttr.update(paramsData).success){
                                common.message("success","属性信息保存成功！");
                            }
                        }
                    });
                }
                $this.close = function(){
                    common.redirectTo("/#/appConfig/" + arrId[1]);
                }
               
            },
            template: require("./AttrItem.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/appConfig/template/EditAttr.js
// module id = 139
// module chunks = 0